import React from "react";
import PropTypes from "prop-types";
//Material Imports
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { useCustomerHistoryContext } from "../../hooks/customer-history/CustomerHistoryContext";
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import MessageHistoryListItem from "./MessageHistoryListItem";
const useStyles = makeStyles(theme => ({
  alignCenter: {
    paddingTop: "10px",
    textAlign: "center"
  },
  noMessageTxt: {
    padding: "10px 0px 10px 15px"
  },
  mhlContainer: {
    position: "relative",
    overflow: "auto",
    paddingTop: "0px",
    flex: "1 1 auto"
  },
  header: {
    backgroundColor: theme.palette.history ? theme.palette.history.backgroundColor : "#f7f8fa",
    color: theme.palette.history ? theme.palette.history.textColor : "#525252",
    borderBottom: "1px solid #f3f4f5",
    paddingTop: 0,
    paddingBottom: 0
  }
}));
const MessageHistoryList = ({
  onMessageHistoryClick
}) => {
  const {
    history
  } = useCustomerHistoryContext();
  const {
    t
  } = useTranslation();
  const classes = useStyles();
  const {
    loading,
    activeMessages,
    previousMessages
  } = history;
  const getItems = messages => {
    if (loading) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.alignCenter
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 24
      }));
    }
    if (!messages || messages.length === 0) {
      return /*#__PURE__*/React.createElement(Typography, {
        className: classes.noMessageTxt,
        component: "div"
      }, t("No messages"));
    } else {
      return messages.map((item, key) => {
        return /*#__PURE__*/React.createElement(MessageHistoryListItem, {
          key: key,
          message: item,
          onClickHandle: onMessageHistoryClick
        });
      });
    }
  };
  return /*#__PURE__*/React.createElement(List, {
    className: classes.mhlContainer,
    component: "div"
  }, /*#__PURE__*/React.createElement(ListSubheader, {
    classes: {
      root: classes.header
    },
    component: "div"
  }, t("Active Conversations")), getItems(activeMessages), /*#__PURE__*/React.createElement(ListSubheader, {
    classes: {
      root: classes.header
    },
    component: "div"
  }, t("Previous Conversations")), getItems(previousMessages));
};
export default MessageHistoryList;
MessageHistoryList.propTypes = {
  onMessageHistoryClick: PropTypes.func.isRequired
};